export const TIRE_SET_REQUEST_PDF_COLUMNS = [
  'setNumber',
  'requestHomeBranch',
  'storageWarehouse',
  'storageLocation',
  'wheelNumber',
  'neededAt',
  'requestType',
  'requestState',
  'requestDestinationBranch',
  'wheelState',
  'tireManufacturer',
  'tireCategory',
  'tireSeason',
  'tireWheel',
] as const;
